// extracted by mini-css-extract-plugin
module.exports = {"def":"_type_def__2qUBp","dense":"_type_dense__3QkMC"};